<template>
<div class="game_container">
    <div class="game_top_box">
    <div class="game_top_img">
        <img :src="topbgSrc" width="100%" height="100%" alt="" />
    </div>
    <div class="game_top_title">EPISODE 3</div>
    <div class="top_button_box" v-if="alreadyApply == false">
        <button class="top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
        COUNT ME IN
        </button>
    </div>
    </div>

    <div class="container_box" :style="backgroundDiv">
        <div class="left_box">
        <div class="left_title_img"><img :src="titleImgSrc" width="100%" height="100%" alt="" /></div>
        <div class="left_title_txt">RIDE TO THE TOP</div>
        <div class="left_title_desc">EPISODE 3</div> 
        <div v-for="(item, index) in topThreeList" :key="index">
            <div class="left_item_box">
            <div class="left_item_content">
                <div class="left_avatar_box">
                <div v-if="index==0">
                    <!-- <div class="left_avator_tag"><img :src="topOneTagSrc" width="100%" height="100%" /></div> -->
                    <div class="left_avator">
                    <img :src="item.userAvatar" width="100%" height="100%" class="left_avator_img_0" />
                    </div>
                </div>
                <div v-if="index==1">
                    <!-- <div class="left_avator_tag"><img :src="topTwoTagSrc" width="100%" height="100%" /></div> -->
                    <div class="left_avator">
                    <img :src="item.userAvatar" width="100%" height="100%" class="left_avator_img_1" />
                    </div>
                </div>
                <div v-if="index==2">
                    <!-- <div class="left_avator_tag"><img :src="topThreeTagSrc" width="100%" height="100%" /></div> -->
                    <div class="left_avator">
                    <img :src="item.userAvatar" width="100%" height="100%" class="left_avator_img_2" />
                    </div>
                </div>
                </div>
                <div class="left_name_value">
                <div class="left_name">{{item.userName}}</div>
                <div class="left_value" v-if="index == 0">{{item.score}}</div>
                <div class="left_value_1" v-if="index == 1">{{item.score}}</div>
                <div class="left_value_2" v-if="index == 2">{{item.score}}</div>
                </div>
            </div>
            <div v-if="index == 0">
                <div class="left_rank_no"><img :src="rankNoFirstSrc" width="100%" height="100%"></div>
            </div>
            <div v-if="index == 1">
                <div class="left_rank_no"><img :src="rankNoSencodSrc" width="100%" height="100%"></div>
            </div>
            <div v-if="index == 2">
                <div class="left_rank_no"><img :src="rankNoThridSrc" width="100%" height="100%"></div>
            </div>
            </div>
        </div>
        </div>
        <div class="right_box">
        <div class="right_top_title_box">
            <div class="right_top_time">{{laveDay}}<span>day</span>{{laveHours}}
            <span>hours</span>{{laveMinutes}}<span>minutes</span>{{laveSeconds}}<span>seconds  left</span>
            </div>
        </div>
        <div class="right_title_box">
            <div class="right_rank_title">Rank </div>
            <div class="right_name_title">Username </div>
            <div class="right_points_title">Points </div>
        </div>
        <div v-for="(item, index) in ranksList" :key="index">
            <div v-if="item.userName != myself.userName" class="right_item_box">
            <div class="right_rank_box">{{item.rankNum }}</div>
            <div class="right_avatar_name">
                <div class="right_avatar">
                    <div v-if="itemsContains(item.userAvatar)">
                        <img :src="item.userAvatar" width="100" height="100" class="right_avatar_img" />
                    </div>
                    <div v-else>
                        <img :src="defaultHead" width="100" height="100" class="right_avatar_img" />
                    </div>
                </div>
                <div class="right_name_box">{{item.userName}}</div>
            </div>
            <div class="right_points_box">{{ item.score }} </div>
            </div>
            <div class="right_item_box_self" v-else>
            <div class="right_my_self_no">{{item.rankNum }}</div>
            <div class="right_avatar_name">
                <div class="right_my_self_name">You Currently Rank</div>
            </div>
            <div class="right_my_self_points">{{ item.score }} </div>
            </div>
        </div>
        </div>
    </div>

    <div class="game_center_box">
    <img :src="centerbgSrc" width="100%" height="100%" alt="" />
    <div class="game_center_txt">
        GAME SLOT: {{gameSlot}}
    </div>
    <div v-if="alreadyApply">
        <div class="game_center_right_title">
            YOU'RE IN
        </div>
        <div class="game_center_right_subtitle">
            if you really have to leave the game, <span class="game_button_right_txt_span" v-on:click="exitGameEvent">click here</span>
        </div>
    </div>
    <div v-else>
        <div class="game_center_right_txt">
            Registration is open until {{deadline}}
        </div>
        <div class="game_center_button">
            <button class="top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
            COUNT ME IN
            </button>
        </div>
    </div>
    </div>

    <div class="game_bottom_box">
    <div class="game_bottom_img">
        <img :src="bottombgSrc" width="100%" height="100%" alt="" />
    </div>
    <div class="game_bottom_left_txt">
        The prizes are...
    </div>
    <div v-if="alreadyApply">
        <div class="game_bottom_right_title">
            YOU'RE IN
        </div>
        <div class="game_bottom_right_subtitle">
            if you really have to leave the game, <span class="game_button_right_txt_span" v-on:click="exitGameEvent">click here</span>
        </div>
    </div>
    <div v-else>
        <div class="game_bottom_right_txt">
            Registration is open until {{deadline}}
        </div>
        <div class="bottom_button_box">
        <button class="top_button" v-on:click="applyJoinGameEvent" :disabled="isDisable">
            COUNT ME IN
        </button>
        </div>
    </div>
    </div>

    <div :class="dialogVisible ? 'float_bg_box_color':'float_bg_box'">
    <div :class="dialogVisible ? 'float_box' : 'show-float'" :style="floatBackground">
        <div class="float_title">YOU ARE IN! </div>
        <div class="float_content">see you on the leaderboard!</div>

        <button class="float_button" v-on:click="sureEvent">
        SURE
        </button>
    </div>
    </div>

</div>
</template>

<script>
  import api from '../api/http';
  import utils from '../utils/numberUtils';
  import dateFilter from '../utils/dateFilter';
  import {
    Message
  } from 'element-ui';

  export default {
    name: 'GameRanking',
    data() {
      return {
        isMobile: false,
        topbgSrc: require('../assets/game-1.png'),
        centerbgSrc: require('../assets/game-2.png'),
        bottombgSrc: require('../assets/game-3.png'),
        floatBackground: {
        backgroundImage: 'url(' + require('../assets/float-bg.png') + ')'
        },
        dialogVisible: false,
        gameSlot: '',
        deadline: '',
        alreadyApply: false,
        stopApply: true,
        endTime: 0,
        isDisable: false,

        backgroundDiv: {
          backgroundImage: 'url(' + require('../assets/match-bg.png') + ')'
        },
        titleImgSrc: require('../assets/match-title.png'),
        rankNoFirstSrc: require('../assets/number-1.png'),
        rankNoSencodSrc: require('../assets/number-2.png'),
        rankNoThridSrc: require('../assets/number-3.png'),
        upSrc: require('../assets/up_arrow.png'),
        defaultHead: require('../assets/default-head.png'),
        ranksList: [],
        topThreeList: [],
        myself: {},
        timer: null,
        currentTime: '',
        laveDay: 0,
        laveHours: 0,
        laveMinutes: 0,
        laveSeconds: 0
      }
    },
    
    methods: {
       async getGameInfoEvent()  {
            let query = this.$route.query;
            let mail = query.email;
            if (mail == 'null' || mail == '' || mail == 'undefined') {
                Message.error('server error');
                return
            }
            let params = {
                'email': mail
            }
            await api.get('client-api/v1/game/info', params).then((res) => {
                if (res.data.code == 200) {
                    let data = res.data.data;
                    this.gameSlot = data.gameSlot;
                    this.deadline = data.deadline;
                    this.alreadyApply = data.alreadyApply;
                    this.stopApply = data.stopApply;
                    this.endTime = data.endTime;
                } else {
                    Message.error(res.data.msg);
                    return
                }
            }).catch (error => {
                Message.error(error);
            })
        },
        applyJoinGameEvent() {
            this.isDisable = true;
            if(this.stopApply) {
                this.$router.push('/pc-rttt-4-rank');
                return;
            }
            let query = this.$route.query;
            let mail = query.email;
            if (mail == 'null' || mail == '' || mail == 'undefined') {
                Message.error('server error');
                return
            }
            let params = {
                'email': mail
            }
            api.post('client-api/v1/game/apply', params).then((res) => {
                this.isDisable = false;
                if (res.data.code == 200) {
                    this.dialogVisible = true;
                } else {
                    Message.error(res.data.msg);
                    return
                }
            }).catch (error => {
                this.isDisable = false;
                Message.error(error);
            })
        },
        exitGameEvent() {
            let query = this.$route.query;
            let mail = query.email;
            if (mail == 'null' || mail == '' || mail == 'undefined') {
                Message.error('server error');
                return
            }
            let params = {
                'email': mail
            }
            api.post('client-api/v1/game/apply/cancel', params).then((res) => {
                if (res.data.code == 200) {
                    this.alreadyApply = false;
                } else {
                    Message.error(res.data.msg);
                    return
                }
            }).catch (error => {
                Message.error(error);
            })
        },
        sureEvent() {
            this.dialogVisible = false;
            this.alreadyApply = true;
        },
        async getRanking()  {
          let query = this.$route.query;
          let name = query.name;
          let params = {
            'userName': name
          } //wzlk client-api/v1/game/rank
          await api.get('client-api/v1/game/rank', params).then(res => {
            if (res.data.code != 200) {
              Message.error(res.data.msg)
              return
            } else {
              let resource = res.data.data
              var newList = []
              var newArray = []

              resource.forEach((item, index) => {
                var map = item
                map['score'] = utils.numberFormat(item.score)
                if (index < 3) {
                  newList.push(map)
                } else {
                  newArray.push(map)
                }
                if (item.userName == name) {
                  this.myself = item
                }
              });
              if (newList.length > 1) {
                this.mTopOneAvatar = newList[0].userAvatar;
              }
              if (newList.length > 2) {
                this.mTopOneAvatar = newList[1].userAvatar;
              }
              if (newList.length > 3) {
                this.mTopOneAvatar = newList[2].userAvatar;
              }
              this.topThreeList = newList;

              this.ranksList = newArray;
            }

            console.log(res);
          })
          .catch(error => {
            throw error
          })
      },
      getCurrentTime() {
        const endTimeDate = this.endTime/1000;
        const nowTimeDate = new Date().getTime()/1000;
        if(nowTimeDate <= endTimeDate) {
          //获取时间差
          let timediff = Math.round((endTimeDate-nowTimeDate));
          //获取还剩多少天
          let day = parseInt(timediff/3600/24);
          this.laveDay = day < 10 ? '0' + day : day;
          //获取还剩多少小时
          let hours =  parseInt(timediff/3600%24);
          this.laveHours = hours < 10 ? '0' + hours : hours;
          //获取还剩多少分钟
          let minutes = parseInt(timediff/60%60);
          this.laveMinutes = minutes < 10 ? '0' + minutes : minutes;
          //获取还剩多少秒
          let seconds = timediff%60;
          this.laveSeconds = seconds < 10 ? '0' + seconds : seconds;
        }
        // //获取当前时间
        // let mm = new Date().getMonth() + 1;
        // let dd = new Date().getDate();
        // let hh = new Date().getHours();
        // let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
        // let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
        // this.currentTime = mm + '/' + dd + ' ' + hh + ':' + mf + ':' + ss;
      },
      itemsContains(val){
        return val.indexOf('http') > -1
      }
    },
    mounted() {
      this.getGameInfoEvent();
      this.getRanking();
      
      
      this.timer = setInterval(() => {
        this.getCurrentTime();
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  @import '../fonts/font.css';

  /**  pc style */
  .game_container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-width: 1024px;
  }

  .game_top_box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .game_top_img {
    width: 100%;
    height: auto;
    font-size: 0;
  }
  .game_top_title {
    position: absolute;
    bottom: 36%;
    left: 7%;
    color: rgba(255, 255, 255, 0.8);
    font-family: Montserrat-Medium;
    font-size: 36px;
  }
  .top_button_box {
    position: absolute;
    bottom: 20%;
    left: 7%;
  }

  .top_button {
    width: 320px;
    height: 60px;
    font-size: 20px;
    border: 0;
    margin: 0;
    color: #ffffff;
    background: linear-gradient(135deg, #7d00ff 0%, #8f0af5 49%, #ff5fa2 100%);
    box-shadow: 0 12px 16px 0 rgba(143, 10, 245, 0.35), 0 17px 50px 0 rgba(255, 95, 162, 0.35);
    font-family: Montserrat-Bold;
    font-weight: bold;
    cursor: pointer;
  }

  .game_center_box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #F6F2F7;
    position: relative;
    width: 100%;
  }

  .game_center_txt {
    position:absolute;
    left: 10.5%;
    top: 20%;
    color: rgba(255, 255, 255, 0.8);
  }
  .game_center_right_txt {
    position:absolute;
    right: 5.5%;
    top: 16.5%;
    color: rgba(255, 255, 255, 0.7);
    width: 360px;
    text-align: right;
  }
  
  .game_center_right_title {
      position:absolute;
      right: 5.5%;
      top: 18%;
      color: rgba(255, 255, 255, 0.9); 
      width: 320px; 
      text-align: center;
      font-family: Montserrat-Bold;
      font-size: 24px;
      font-weight: bold;
  }
  .game_center_right_subtitle {
      position: absolute;
      right: 5.5%;
      top: 24%;
      color: rgba(255, 255, 255, 0.7);  
  }

  
  .game_center_button {
    position:absolute;
    right: 5.5%;
    top: 20.5%;
    color: rgba(255, 255, 255, 0.7);   
  }
  
  .game_center_title {
    font-size: 36px;
    color: #333333;
    margin-top: 50px;
  }

  .game_bottom_box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
  }
  .game_bottom_left_txt {
    position:absolute;
    left: 10.5%;
    top: 14%;
    color: rgba(255, 255, 255, 0.8);
  }
  .game_bottom_right_title {
      position:absolute;
      right: 5.5%;
      top: 13%;
      color: rgba(255, 255, 255, 0.9); 
      width: 320px; 
      text-align: center;
      font-family: Montserrat-Bold;
      font-size: 24px;
      font-weight: bold;
  }
  .game_bottom_right_subtitle {
      position: absolute;
      right: 5.5%;
      top: 17%;
      color: rgba(255, 255, 255, 0.7);  
  }
  .game_bottom_right_txt {
    position:absolute;
    right: 5.5%;
    top: 11%;
    color: rgba(255, 255, 255, 0.7);
    width: 360px;
    text-align: right;
  }

  .bottom_button_box {
    position: absolute;
    right: 5.5%;
    top: 14%;
  }

  .game_button_right_txt_span {
      color: #8505FB;
      cursor: pointer;
      /* text-decoration: underline; */
  }

  .game_bottom_img {
    width: 100%;
    height: auto;
    font-size: 0;
  }

  .game_footer {
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .footer_text {
    font-size: 36px;
    color: #fff;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .footer_description {
    margin-top: 60px;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
    width: 600px;
  }

  .float_bg_box {
    display: none;
    position: absolute;
    width: 100%;
    height: 370%;
    left: 0;
    top: 0;
  }

  .float_bg_box_color {
    display: block;
    background: rgba(0, 0, 0, 0.7);
    position: absolute;
    width: 100%;
    height: 370%;
    left: 0;
    top: 0;
  }

  .float_box {
    display: block;
    width: 880px;
    height: 480px;
    position: fixed;
    left: calc(50% - 440px);
    top: calc(20%);
  }

  .float_title {
    color: #fff;
    font-size: 36px;
    font-weight: 600;
    margin-top: 114px;
    font-family: Montserrat-Bold;
  }

  .float_content {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 1px;
    color: #fff;
    margin-top: 24px;
    font-family: Montserrat-Regular;
  }

  .show-float {
    display: none;
  }

  .float_button {
    margin: 0 auto;
    width: 320px;
    height: 60px;
    background: linear-gradient(135deg, #7D00FF 0%, #8F0AF5 49%, #FF5FA2 100%);
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    margin-top: 117px;
    cursor: pointer;
  }

/** this is  Match Ranking Style */
  .container_box {
    font-weight: normal;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    padding-top: 64px;
    /* padding-bottom: 108px; */
    min-width: 1080px;
    width: 100%;
    height: 100%;
  }

  .left_box {
    width: 35%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 40px;
  }

  .left_title_img {
    width: 55%;
    /* margin-bottom: 90px; */
  }

  .left_title_txt {
    color: #fff;
    font-size: 25px;
    font-weight: 400;
    margin-top: 20px;
    /* margin-bottom: 40px; */
    font-family: Montserrat-Medium;
  }
  .left_title_desc {
    margin-top: 2px;
    margin-bottom: 34px;
    font-size: 20px;
    font-family: Montserrat-Regular, Montserrat;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    line-height: 48px;
  }

  .left_item_box {
    width: 26.25rem;
    position: relative;
  }

  .left_item_content {
    width: 100%;
    height: 168px;
    background-color: #473654;
    border-radius: 8px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .left_avatar_box {
    width: 46%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
  }

  .left_avator_tag {
    width: 74px;
    height: 67px;
    position: absolute;
    top: 0px;
    left: 108px;
  }

  .left_avator {
    width: 86px;
    height: 86px;
    border-radius: 50%;
    position: relative;
    margin-left: 10px;
  }

  .left_avator_img_0 {
    border-radius: 50%;
    border: 3px solid #FF9A00;
  }

  .left_avator_img_1 {
    border-radius: 50%;
    border: 3px solid #00BFE8;
  }

  .left_avator_img_2 {
    border-radius: 50%;
    border: 3px solid #FF4DA3;
  }

  .left_name_value {
    width: 54%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 20px;
  }

  .left_name {
    width: 180px;
    font-size: 16px;
    font-weight: 400;
    color: rgb(255, 255, 255, 0.8);
    font-family: Montserrat-Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .left_value {
    font-size: 40px;
    font-weight: 500;
    color: #FF9A00;
    line-height: 47px;
    margin-top: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .left_value_1 {
    font-size: 40px;
    font-weight: 500;
    color: #00BFE8;
    line-height: 47px;
    margin-top: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .left_value_2 {
    font-size: 40px;
    font-weight: 500;
    color: #FF4DA3;
    line-height: 47px;
    margin-top: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .left_rank_no {
    width: 3.75rem;
    height: 3.75rem;
    position: absolute;
    left: -7%;
    top: 35%;
  }

  .right_box {
    width: 65%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-right: 120px;
    color: rgb(255, 255, 255, 0.8);
    font-size: 16px;
    margin-left: 40px;
  }

  .right_top_title_box {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .right_top_title {
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 50px;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .right_top_time {
    font-size: 60px;
    color: #4949C5;
    line-height: 50px;
    margin-left: 18px;
    font-family: DINCond-Bold;
    font-weight: 500;
  }
  .right_top_time>span {
    margin-left: 8px;
    margin-right: 33px;
    color: rgb(255, 255, 255, 0.8);
    font-size: 16px;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .right_title_box {
    display: flex;
    flex-direction: row;
    height: 56px;
    align-items: center;
    font-size: 16px;
    color: rgb(255, 255, 255, 0.8);
    margin-top: 18px;
    font-family: Montserrat-Medium;
    font-weight: 500;
  }

 .right_rank_title {
    width: 20%;
  }

  .right_name_title {
    width: 60%;
    text-align: left;
    margin-left: 85px;
  }

  .right_points_title {
    width: 20%;
    text-align: right;
    margin-right: 100px;
  }

  .right_item_box {
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: rgb(255, 255, 255, 0.15);
    border-radius: 4px;
    margin-top: 15px;
  }

  .right_item_box_self {
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #303095;
    border-radius: 4px;
    margin-top: 15px;
  }

  .right_rank_box {
    width: 20%;
    font-size: 20px;
    font-weight: 500;
    color: rgb(255, 255, 255, 0.8);
    font-family: Montserrat-Medium;
  }

  .right_item_my_self {
    display: flex;
    flex-direction: row;
    width: 50%;
  }

  .right_myself_name,
  .right_avatar_name {
    display: flex;
    flex-direction: row;
    width: 50%;
  }

  .right_my_self_no {
    width: 20%;
    font-size: 24px;
    font-family: Montserrat-Bold;
    font-weight: bold;
    color: #FFFFFF;
  }

  .right_my_self_name {
    width: auto;
    text-align: left;
    font-family: Montserrat-Medium;
    font-weight: 600;
  }

  .right_my_self_points {
    width: 30%;
    font-size: 36px;
    color: rgb(255, 255, 255, 0.8);
    margin-left: 60px;
    font-family: DINCond-Bold;
    font-weight: bold;
    text-align: right;
    margin-right: 100px;
  }

  .right_avatar {
    text-align: right;
  }

  .right_avatar_img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
  }

  .right_name_box {
    width: 50%;
    text-align: left;
    margin-left: 40px;
    align-self: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .right_points_box {
    width: 30%;
    font-size: 30px;
    font-weight: 500;
    color: rgb(255, 255, 255, 0.8);
    margin-left: 60px;
    font-family: DINCond-Bold;
    font-weight: bold;
    text-align: right;
    margin-right: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/CyclingPadRanking.vue